import React from 'react';
import Visualizer from './components/visualizer';
import './App.css';

function App() {
  return (
    <Visualizer/>
  );
}

export default App;
